// 국내 카드사 코드
// https://docs.tosspayments.com/codes/org-codes
const CARD_BRAND_LABELS = {
  "3K": "기업비씨",
  "46": "광주은행",
  "71": "롯데카드",
  "30": "한국산업은행",
  "31": "BC카드",
  "51": "삼성카드",
  "38": "새마을금고",
  "41": "신한카드",
  "62": "신협",
  "36": "씨티카드",
  "33": "우리BC카드(BC 매입)",
  "W1": "우리카드(우리 매입)",
  "37": "우체국예금보험",
  "39": "저축은행중앙회",
  "35": "전북은행",
  "42": "제주은행",
  "15": "카카오뱅크",
  "3A": "케이뱅크",
  "24": "토스뱅크",
  "21": "하나카드",
  "61": "현대카드",
  "11": "KB국민카드",
  "91": "NH농협카드",
  "34": "Sh수협은행",
  // PCP: "페이코",
  // KBS: "KB증권",
};

export const getPaymentCardBrandLabel = (cardBrandCode) => {
  if (!cardBrandCode) return;

  return CARD_BRAND_LABELS[cardBrandCode] ?? cardBrandCode;
};
